import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "container"];
  static values = {
    uuid: String,
    counter: {
      type: Number,
      default: 0,
    },
  };

  /*
   * When adding a new nested form, we replace the UUID informed for a
   * new one.  In this way we can create unique nested hashes that Rails
   * can understand and various levels of nesting.
   */
  add(event) {
    this.counterValue = this.counterValue + 1;

    const template = this.formTarget.content.cloneNode(true);
    const uuid = self.crypto.randomUUID();

    for (const input of template.querySelectorAll("[name]")) {
      for (const label of input.labels) {
        label.setAttribute(
          "for",
          label.getAttribute("for").replace(this.uuidValue, uuid),
        );
      }

      input.id = input.id.replace(this.uuidValue, uuid);
      input.name = input.name.replace(this.uuidValue, this.counterValue);
    }

    for (const attribute of [
      "data-form-dependencies-id",
      "data-form-dependencies-dependents-param",
    ]) {
      for (const element of template.querySelectorAll(`[${attribute}]`)) {
        element.setAttribute(
          attribute,
          element.getAttribute(attribute).replaceAll(this.uuidValue, uuid),
        );
      }
    }

    this.containerTarget.appendChild(template);
  }

  del(event) {
    event.target.parentElement.remove();
  }
}
